//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uiBottom from '@/component/uiBottom'
import { getUserInfo, isApp } from '@/util/const'
import { setAuthorization } from '../../axios/userInfo'

export default {
  components: {
    uiBottom
  },
  data () {
    return {
      btnText: [this.$t('concert.concert31'), this.$t('concert.concert30'), this.$t('concert.concert25')],
      btnIndex: 3,
      applyOver: Number(this.$route.params.applyOver),
      applyEnd: true,
      result: {
        ctr: true,
        msg: ''
      }
    }
  },
  created () {
    window.getUserInfo = (obj) => {
      if (obj) {
        setAuthorization(obj.authorization)
        console.log(obj)
        if (obj.boss) {
          this.userValid()
        } else {
          this.$router.replace({ path: '/invalidPage' })
        }
      }
    }
    this.$http.pageInvalidIf().then(res => {
      if (res.data.body['404']) {
        if (this.applyOver === 1) {
          this.applyEnd = false
          this.btnIndex = 1
        } else {
          location.href = `http://${window.location.host}/mylink/#/invalidPage`
        }
      } else {
        if (isApp()) {
          getUserInfo({ callbackName: 'getUserInfo', needLogin: true })
        } else {
          setAuthorization('d4276c32-2768-4519-8620-e41e23ca9213')
          this.userValid()
        }
      }
    })
  },
  methods: {
    jump () {
      if (this.btnIndex === 0) {
        this.$router.push({ path: '/applyForm' })
      } else if (this.btnIndex === 1) {
        location.href = 'cmcchkh5action://close'
      } else if (this.btnIndex === 2) {
        location.href = 'openpage://50300'
      }
    },
    userValid () {
      this.$http.get(`/v1/api/user/hanaConcert/checkUser`, { type: this.applyOver }).then(res => {
        switch (res.data.body.result) {
          case 1:
            this.result.ctr = true
            this.result.msg = this.$t('concert.concert29')
            this.btnIndex = 1
            this.$http.clickRate('event_concert_check_page')
            break
          case 2:
            this.result.ctr = false
            this.btnIndex = 0
            this.$http.clickRate('event_concert_sign_up_page')
            break
          case 3:
            this.result.ctr = true
            this.result.msg = this.$t('concert.concert19')
            this.btnIndex = 3
            this.$http.clickRate('event_concert_check_page_pending')
            document.title = this.$t('concert.concert19')
            break
          case 4:
            this.result.ctr = true
            this.result.msg = this.$t('concert.concert24')
            this.btnIndex = 2
            this.$http.clickRate('event_concert_check_page_finished')
            document.title = this.$t('concert.concert23')
            break
          case 5:
            location.href = `${window.location.origin}${window.location.pathname}#/applySuccess`
            // this.$router.push({ path: '/applySuccess' })
            break
          case 6:
            this.$router.push({ path: '/invalidPage' })
            break
          default:
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/concert/index.vue